import React from 'react'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import MakePaymentPageWidget  from './makePaymentPageWidget'
import NavWidge2 from '../../../../widget/Nav/NavWidget2'
function MakePayment() {
  return (
    <div>
        <NavWidge2/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m10'>
                {/* <div className='container'> */}
                   <MakePaymentPageWidget/>
                {/* </div> */}
            </div>
        </div>
    </div>
  )
}

export default MakePayment